import { Alert, Box, Button, Snackbar, Typography } from '@mui/material';

interface LimitAlertProps {
	isAlertOpen: boolean;
	handleClose: () => void;
	handleActionButtonClick: () => void;
}

function LimitAlert({
	isAlertOpen,
	handleClose,
	handleActionButtonClick,
}: LimitAlertProps) {
	return (
		<Snackbar
			open={isAlertOpen}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
			<Alert
				severity="warning"
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: 2,
				}}>
				<Box sx={{ display: 'flex', flexDirection: 'row' }}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							marginX: '10px',
						}}>
						<Typography
							variant="body1"
							sx={{ fontWeight: 'bold', color: '#78350F' }}>
							Sandbox Limit Reached
						</Typography>

						<Typography variant="body2" sx={{ color: '#78350F' }}>
							⚠️ You&apos;ve reached your limit. Please upgrade to
							continue.
						</Typography>
					</Box>
					<Button
						onClick={handleActionButtonClick}
						style={{
							boxShadow: 'none',
							textTransform: 'none',
							color: '#78350F',
							backgroundColor: '#FFFFFF',
							marginLeft: '10px',
						}}
						variant="contained">
						Resolve
					</Button>
				</Box>
			</Alert>
		</Snackbar>
	);
}

export default LimitAlert;
